import React, { useState } from "react"
import { connect, useDispatch, useSelector } from "react-redux"
import { Button, Modal } from "react-bootstrap"
import * as actions from "../actions/websocket"
import axios from "axios"

import config from "../config"

const SIZE = 1048576 * 15 // 1 Megabyte * size for test
const MIN_SPEED = 2 // in megabit's

// check user browser, iceServers connection and access to microphone and shows notification if fail
class SelfSpeedCheck extends React.PureComponent {
    state = {
        status: "unknown",
        show: this.props.show,
    }

    componentDidMount = () => {
        if (this.props.startTest) {
            this.handleStart()
        }
    }

    componentDidUpdate = () => {
        if (this.props.show !== this.state.show) {
            this.setState({ show: this.props.show })
        }

        if (this.state.status === "testing") {
            this.test()
            this.props.eventHandler.onProgress('testing')
        }
    }

    test = () => {
        if (this.startTime) {
            return
        }

        const timeout = ((SIZE * 8) / (MIN_SPEED * 1000000)) * 1000
        this.startTime = new Date().getTime()
        Promise.all([this.download(SIZE, timeout), this.upload(SIZE, timeout)])
            .then(res => {
                let responseStatus = {}
                if (res[0] === "error" || res[1] === "error") {
                    this.setState({ status: "error" })
                    responseStatus['status'] = "error"
                    this.props.eventHandler.onFinish(responseStatus)
                } else if (res[0] === "fail" || res[1] === "fail") {
                    this.setState({ status: "fail" })
                    responseStatus['status'] = "fail"
                    responseStatus['download'] = res[0]
                    responseStatus['upload'] = res[1]
                    this.props.eventHandler.onFinish(responseStatus)
                } else {
                    if (res[0].speedMbp < MIN_SPEED || res[1].speedMbps < MIN_SPEED) {
                        this.setState({ status: "fail" })
                        responseStatus["status"] = "fail";
                        responseStatus["download"] = res[0];
                        responseStatus["upload"] = res[1];
                        this.props.eventHandler.onFinish(responseStatus)
                    }
                    responseStatus["status"] = "success";
                    responseStatus["download"] = res[0];
                    responseStatus["upload"] = res[1];
                    this.props.eventHandler.onFinish(responseStatus)
                    this.setState({ status: "success" })
                }

                this.props.dispatch(actions.send("checks_speed_test", { download: res[0], upload: res[1] }))
            })
            .finally(() => {
                this.startTime = null
            })
    }

    download = (size, timeout) => {
        const baseUrl = `${config.apiEndpoint}checks/download/${size}?t=${Date.now()}`
        let endTime
        let downloadStart = false

        return new Promise(resolve => {
            axios
                .get(baseUrl, {
                    timeout,
                    onDownloadProgress: () => {
                        downloadStart = true
                    },
                })
                .then(() => {
                    endTime = new Date().getTime()
                    const duration = (endTime - this.startTime) / 1000
                    const bitsLoaded = size * 8
                    const speedBps = (bitsLoaded / duration).toFixed(2)
                    const speedKbps = (speedBps / 1024).toFixed(2)
                    const speedMbps = (speedKbps / 1024).toFixed(2)
                    resolve({ start: this.startTime, end: endTime, duration, downloaded: size, speedKbps, speedMbps })
                })
                .catch(e => {
                    if (downloadStart && e.message && e.message.includes("timeout")) {
                        resolve("fail")
                        return
                    }
                    resolve("error")
                })
        })
    }

    upload = (size, timeout) => {
        const baseUrl = `${config.apiEndpoint}checks/upload/${size}?t=${Date.now()}`
        let endTime
        let uploadStart = false

        const blob = new Blob([this.generateTestData(size)], { type: "application/octet-stream" })
        const formData = new FormData()
        formData.append("file", blob)

        return new Promise(resolve => {
            axios
                .post(baseUrl, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    timeout,
                    onUploadProgress: () => {
                        uploadStart = true
                    },
                })
                .then(() => {
                    endTime = new Date().getTime()
                    const duration = (endTime - this.startTime) / 1000
                    const bitsLoaded = size * 8
                    const speedBps = (bitsLoaded / duration).toFixed(2)
                    const speedKbps = (speedBps / 1024).toFixed(2)
                    const speedMbps = (speedKbps / 1024).toFixed(2)
                    resolve({ start: this.startTime, end: endTime, duration, uploaded: size, speedKbps, speedMbps })
                })
                .catch(e => {
                    if (uploadStart && e.message && e.message.includes("timeout")) {
                        resolve("fail")
                        return
                    }
                    resolve("error")
                })
        })
    }

    generateTestData = size => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789~!@#$%^&*()_+`-=[]{}|;':,./<>?"
        var byteArray = new Uint8Array(size)
        for (var x = 0; x < byteArray.length; x++) {
            byteArray[x] = parseInt(chars.substr(x * 2, 2), 16)
        }
        return byteArray
    }

    handleShow = () => {
        // if test in progress skip it
        if (this.state.status === "testing") return

        this.setState({ show: false, status: "unknown" })

        // if fail show chat support window
        if (this.state.status === "fail" && window.fcWidget && window.fcWidget.open) {
            window.fcWidget.open()
        }

        // execute parrent handler
        if (this.props.handleShow) {
            this.props.handleShow()
        }
    }

    handleStart = () => {
        this.setState({ status: "testing" })
    }

    render() {
        const { status, show } = this.state

        return (
            <></>
        )
    }
}

export const SelfSpeedCheckButton = ({eventHandler}) => {
    const [show, setShow] = useState(false)
    const showVal = useSelector((state) => state.checks.startTest);
    const dispatch = useDispatch()
    return (
      <>
        {showVal === true && (
          <SelfSpeedCheck
            show={showVal}
            eventHandler={eventHandler}
            startTest={showVal}
            dispatch={dispatch}
          />
        )}
      </>
    );
}

const mapStateToProps = state => {
    return {
        startTest: state.checks.startTest
    }
}

export default connect(mapStateToProps)(SelfSpeedCheck)
